<template>
  <div class="sharing-switcher">
    <div class="sharing-switcher__icon icon-row">
      <!-- Social icon -->
      <slot class="icon-row__icon" name="icon"></slot>
      <autorenew
        class="icon-row__renew renew-icon"
        :class="{ 'renew-icon_clicked': renewClicked }"
        @click="startRenew"
      />
    </div>
    <el-select
      :value="selectedAccountIds"
      :placeholder="placeholder"
      multiple
      collapse-tags
      class="sharing-switcher-account qwe"
      @change="$emit('updateSelectedAccounts', $event)"
    >
      <el-option v-if="accounts.length == 0" :value="0" disabled>
        <!-- No accounts text -->
        <slot name="empty">No accounts</slot>
      </el-option>
      <el-option
        class="selectItem"
        v-for="acc in accounts"
        :key="acc.id"
        :value="acc.id"
        :label="acc.label"
      >
        <!-- Account option (account.label by default) -->
        <slot name="account" class="selectItem" :accountData="acc">{{ acc.label }}</slot>
      </el-option>
    </el-select>
  </div>
</template>

<script>
/** icons */
import Autorenew from "vue-material-design-icons/Autorenew.vue";

// @group Socials
// Share accounts select
export default {
  name: "SharingFormAccountSelect",
  components: {
    Autorenew
  },
  model: {
    prop: "selectedAccountIds",
    event: "updateSelectedAccounts"
  },
  props: {
    /** selected account identifiers */
    selectedAccountIds: {
      type: Array,
      default: () => []
    },
    /** available to select accounts */
    accounts: {
      type: Array,
      default: () => []
    },
    /** select placeholder text */
    placeholder: {
      type: String,
      default: "Select account"
    }
  },
  data() {
    return {
      renewClicked: false
    };
  },
  methods: {
    // @vuese
    // Start renew animation and pass event to parent
    startRenew() {
      this.$emit("renew");
      this.renewClicked = true;
      setTimeout(() => (this.renewClicked = false), 1000);
    }
  }
};
</script>

<style scoped lang="scss">
.sharing-switcher {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 5px;

  &__icon {
    margin-bottom: 5px;
  }
}
.icon-row {
  position: relative;
  display: flex;
  align-items: center;

  &__renew {
    position: absolute;
    left: 100%;
    width: 20px !important;
    height: 20px !important;
    margin-left: 5px;
  }

  .material-design-icon__svg {
    width: 20px !important;
    height: 20px !important;
  }
}
.renew-icon {
  cursor: pointer;
  color: #ccc;

  transition: transform 0s;

  &:hover {
    color: white;
  }

  &_clicked {
    transition: transform 0.5s;
    transform: rotate(360deg);
  }
}

</style>
<style >
.selectItem{
  background-color: #aaaaaa !important;
}
</style>
